export const environment = {
  production: true,
  apiUrl: "https://api.indisell.com/api/",
  baseUrl: "indisell.com",
  fastBeetleUrl: "https://indisell.com",
  logisticToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmaXJzdE5hbWUiOiJTb2hhaWwiLCJ1c2VybmFtZSI6Ijg4MjUwNTYwMDQiLCJpYXQiOjE3MDMyMzg3ODgsImV4cCI6MTczNDc3NDc4OH0.yJxkQxvmHoxMMIKqec9-PfPyeoBCnomfEiUQxQUkpRk',
  sectionId: 1,
  sellerUrl: 'https://seller.indisell.com',
  wholesaleUrl: 'https://wholesaler.indisell.com',
  instance: 'dev'
};
